import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import ErrorBoundary from '../../ui/error-boundary';
var createSurfaceElement = function createSurfaceElement(type, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }
  return /*#__PURE__*/React.createElement(type, props, children);
};
var incrementBaseHeadingLevel = function incrementBaseHeadingLevel(baseHeadingLevel) {
  var number = Number(baseHeadingLevel.replace('h', ''));
  return "h".concat(Math.min(number + 1, 6));
};
export var createSurfaceRenderer = function createSurfaceRenderer(moduleDictionary) {
  var moduleMap = new Map(Object.entries(moduleDictionary));
  var ZoneRenderer = function ZoneRenderer(_ref) {
    var zones = _ref.zones,
      createMutateAtModule = _ref.createMutateAtModule,
      updateId = _ref.updateId,
      headingLevel = _ref.headingLevel,
      createActionBusAtModule = _ref.createActionBusAtModule,
      context = _ref.context;
    return /*#__PURE__*/React.createElement(React.Fragment, null, zones && Object.values(zones).flatMap(function (selectionItems) {
      return (selectionItems !== null && selectionItems !== void 0 ? selectionItems : []).map(function (selectionItem, i) {
        var module = selectionItem.data;
        if (module === null || !(module !== null && module !== void 0 && module.type) || !(module !== null && module !== void 0 && module.key)) {
          return null;
        }

        // Looks up imported modules, which are (kind of) similar to components and uses that if available
        var componentToRender = moduleMap.get(module.type);
        if (!componentToRender) {
          throw new Error("Surface Renderer tried to render a component of type ".concat(module === null || module === void 0 ? void 0 : module.type, " but no such component exists"));
        }
        var mutate = createMutateAtModule(module.type, module.key);
        return createSurfaceElement(componentToRender, _objectSpread(_objectSpread({}, module === null || module === void 0 ? void 0 : module.fields), {}, {
          id: module.key,
          key: [module.type, module.key, i].join('-'),
          actionBus: createActionBusAtModule(selectionItem),
          context: context,
          mutate: mutate,
          headingLevel: headingLevel
        }), /*#__PURE__*/React.createElement(ZoneRenderer, {
          key: "".concat(Object.keys(zones !== null && zones !== void 0 ? zones : []).join('-'), "-zones "),
          updateId: updateId,
          zones: module === null || module === void 0 ? void 0 : module.zones,
          createMutateAtModule: createMutateAtModule,
          headingLevel: incrementBaseHeadingLevel(headingLevel),
          createActionBusAtModule: createActionBusAtModule,
          context: context
        }));
      });
    }));
  };
  var FallbackHandler = function FallbackHandler(_ref2) {
    var error = _ref2.error,
      isLoading = _ref2.isLoading,
      surface = _ref2.surface,
      fallback = _ref2.fallback,
      children = _ref2.children;
    if (error) {
      if (!error.name || error.name === '') {
        throw new Error("Unnamed error in surface renderer. isLoading: ".concat(isLoading, ", surfaceExists: ").concat(surface !== undefined, ", stack: ").concat(error.stack));
      }
      throw error;
    }
    if (isLoading) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, fallback);
    }
    if (!isLoading && !surface) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  };
  var SurfaceRenderer = function SurfaceRenderer(_ref3) {
    var _surface$zones;
    var surface = _ref3.surface,
      isLoading = _ref3.isLoading,
      fallback = _ref3.fallback,
      error = _ref3.error,
      _ref3$errorFallback = _ref3.errorFallback,
      errorFallback = _ref3$errorFallback === void 0 ? null : _ref3$errorFallback,
      createMutateAtModule = _ref3.createMutateAtModule,
      updateId = _ref3.updateId,
      baseHeadingLevel = _ref3.baseHeadingLevel,
      createActionBusAtModule = _ref3.createActionBusAtModule,
      context = _ref3.context;
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      fallback: errorFallback
    }, /*#__PURE__*/React.createElement(FallbackHandler, {
      surface: surface,
      error: error,
      isLoading: isLoading,
      fallback: fallback
    }, /*#__PURE__*/React.createElement(ZoneRenderer, {
      key: "".concat(Object.keys((_surface$zones = surface === null || surface === void 0 ? void 0 : surface.zones) !== null && _surface$zones !== void 0 ? _surface$zones : []).join('-'), "-zones "),
      updateId: updateId,
      zones: surface === null || surface === void 0 ? void 0 : surface.zones,
      createMutateAtModule: createMutateAtModule,
      headingLevel: baseHeadingLevel,
      createActionBusAtModule: createActionBusAtModule,
      context: context
    })));
  };
  return SurfaceRenderer;
};